import React from 'react';
import PropTypes from 'prop-types';

import { mapUnit } from '../util/topic.js';

import { TypeGroupRow } from './TypeGroupRow.js';

import { getNamedRoot, sensorSubTypeToTitle } from '../util/topic.js';

const mapTypeToTopics = {
    'o': [
        'switch',
        'Current',
        'PowerW',
        'PowerFactor',
        'Voltage',
        'KWhTotal'
    ],
    'i': [
        'Current',
        'PowerW',
        'Voltage',
        'KWhTotal'
    ],
    's': ['val']
};

const standardSort = [
    'Current',
    'PowerW',
    'KWhTotal',
    'TEMPERATURE',
    'HUMIDITY'
];
// const fallbackMap = mapTypeToTopics.o.slice().splice(0, 0, '')

export class TypeGroupComponent extends React.Component {
    static contextTypes = {
        t: PropTypes.func.isRequired,
        p: PropTypes.object.isRequired,
        logged_in_as: PropTypes.string,
        gatewayName: PropTypes.string
    }

    headerTitles = {};

    subs = {};
    subPrm = null;
    subsSnd = [];
    subbedPaths = [];
    state = {
        _loading:false,
        _hasSensors:false,
        _hasPhases:false,
        _rootToPhases:{},
        _sensorTypes:[],
        _multiParents: false
    };

    getPushPath = () => {
        if (this.state.data && this.state.data.type === "RACKDEVICE") {
            // Push components
            const parts = this.props.path.split("/");
            return "comp;" + parts.slice(-1)[0]
        } else {
            return this.props.path;
        }
    }

    getTopicNamesForPath(path) {
        const topic = this.context.p.getPath(path);
        const names = [];
        for (let subPath in topic) {
            const subTopic = topic[subPath];
            // Check if it is a subtopic
            if (subTopic && subTopic.v) {
                names.push(subPath);
            }
        }

        return names;
    }

    unsubscribePath(path) {
        let cbList = this.subs[path];
        // cbList();
        // this.context.p.unsubscribePush(path);
        if (cbList) {
            for (let i in cbList) {
                cbList[i]();
            }
        }
        this.subs[path] = [];
    }

    subscribe = (paths) => {
        const self = this, p = this.context.p;
        this.setState({_loading: true});

        // Get currently subscribed paths
        const currentSubscribedPaths = Object.keys(this.subs);

        // And remove those that should remain subscribed
        for (let i in paths) {
            let path = paths[i];
            let currentIdx = currentSubscribedPaths.indexOf(path);
            if (currentIdx >= 0) {
                currentSubscribedPaths.splice(currentIdx, 1);
            }

            const rootName = getNamedRoot(path);
            if (rootName.indexOf("sensor/") === 0) {
                this.props.subscribeSensor(rootName);
                self.setState({_hasSensors: true});
            }
        }

        // Unsubscribe the remaining
        for (let i in currentSubscribedPaths) {
            const path = currentSubscribedPaths[i];
            this.unsubscribePath(path);
        }

        // Now subscribe those that we don't currently have subscribed
        for (let i in paths) {
            const rootPath = paths[i];

            if (this.subs[rootPath] === undefined) {
                let pushSubs = [
                    p.subscribe(rootPath, self.rootUpdate, true),
                    p.subscribe(rootPath + "/+", (value, path, localPath, bla, wholePath) => {
                        if (this.props.typeId === 's') {
                            return;
                        }
                        self.setState((state, props) => {
                            if (state && state[rootPath] && state[rootPath].indexOf(localPath) === -1) {
                                let update = {_loading: false};
                                update[rootPath] = state[rootPath].concat([localPath]);
                                return update;
                            }
                        });
                    })
                ];
                Promise.all(pushSubs)
                .then(function (unsubscribeCBs, error) {
                    self.subs[rootPath] = unsubscribeCBs;
                });
            }
        }
    }

    rootUpdate = (value, path, localPath, bla, wholePath) => {
        const update = { _loading: false };
        if (this.props.typeId !== 's') {
            update[wholePath] = this.getTopicNamesForPath(wholePath);
        }

        // Check all roots to see if we have phases
        const currentSubscribedPaths = Object.keys(this.subs);
        let rootToPhases = {};
        let sensorTypes = [];
        for (let subscribedPath of currentSubscribedPaths) {
            const rootData = this.context.p.getPath(subscribedPath);

            if (rootData) {
                // Check if it's a sensor
                if (subscribedPath.indexOf("sensor/") === 0) {
                    // See if we have a parent inlet that is not index 0
                    if (this.props.typeId === 'i' && !rootData.parent && rootData.type && rootData.type !== "SUM" && rootData.type !== "SINGLE") {
                        update._multiParents = true;
                    }
                    if (rootData.phase && rootData.parent) {
                        update._hasPhases = true;
                        const parentPath = getNamedRoot(subscribedPath) + "/" + rootData.parent;
                        if (rootToPhases[parentPath] === undefined) {
                            rootToPhases[parentPath] = { [rootData.phase]: subscribedPath };
                        } else {
                            rootToPhases[parentPath][rootData.phase] = subscribedPath;
                        }
                    } else if (this.props.typeId === 's' && rootData.type && sensorTypes.indexOf(rootData.type) === -1) {
                        sensorTypes.push(rootData.type);
                    }
                } else {
                    // Check if it's a group and has at least one phase
                    if (subscribedPath.indexOf("group") === 0 && (
                        rootData.L1 || rootData.L2 || rootData.L3)) {
                        update._hasPhases = true;
                    }
                }
            }
        }

        if (update._hasPhases) {
            update._rootToPhases = rootToPhases;
        }
        if (sensorTypes && this.props.typeId === 's') {
            update._sensorTypes = sensorTypes;
            update[wholePath] = sensorTypes;
        }

        this.setState(update);
    }

    // update = (value, path, localPath, bla, wholePath) => {
    //     this.setState((state, props) => {
    //         if (state[])
    //     })
    //     const stateChange = {};
    //     stateChange[localPath] = this.getTopicNamesForPath(wholePath);
    //     this.setState(stateChange);
    // }

    componentDidMount() {
        const allPaths = this.props.paths.concat(this.props.resultPath ? this.props.resultPath : []);
        this.subscribe(allPaths);
    }

    componentWillUnmount() {
        const p = this.context.p;
        for (let path in this.subs) {
            // const sub = this.subs[path];
            this.unsubscribePath(path);
        }
        this.subs = {};
        this.setState({_hasSensors: false});
    }

    render() {
        const self = this;

        if (!this.props.paths || this.state._loading) {
            return ((
                <div className="item">
                    <div className="inner">
                        No members added.
                    </div>
                </div>
            ));
        }
        function doesTopicExistinPaths(topic) {
            for (let path in self.state) {
                if (path === "_loading" || path === "_hasSensors" || path === "_hasPhases" || path === "_rootToPhases" || path === '_sensorTypes' || path === '_multiParents') {
                    continue;
                }
                const topicList = self.state[path];
                if (topicList && topicList.indexOf(topic) !== -1) {
                    return true;
                }
            }
            return false;
        }
        // If there is a mapping for this typeId, use it
        let unsortedTopics = [];
        let sortedTopics = [];
        const topicMap = mapTypeToTopics[this.props.typeId] ? mapTypeToTopics[this.props.typeId] : standardSort;
        if (this.props.typeId !== 's' && topicMap) {
            // Now first get the topics from the topicmap
            for (let i in topicMap) {
                const topic = topicMap[i];
                if (doesTopicExistinPaths(topic)) {
                    sortedTopics.push(topic);

                    if (topic === "Current" && this.state._hasPhases) {
                        sortedTopics.push("L1");
                        sortedTopics.push("L2");
                        sortedTopics.push("L3");
                        if (!this.headerTitles.L1) {
                            this.headerTitles.L1 = "L1";
                        }

                        if (!this.headerTitles.L2) {
                            this.headerTitles.L2 = "L2";
                        }

                        if (!this.headerTitles.L3) {
                            this.headerTitles.L3 = "L3";
                        }
                    }

                    if (!this.headerTitles[topic]) {
                        this.headerTitles[topic] = this.context.t('topic_titles.' + topic.toLowerCase());
                    }
                }

            }
        } else {
            // If we don't have a map, take all topics that we haven't sorted yet and add them to unsorted
            for (let topic in this.state) {
                const pathList = this.state[topic];
                for (let i in pathList) {
                    const path = pathList[i];
                    if (path.indexOf("Threshold") === -1 && sortedTopics.indexOf(path) === -1) {
                        if (this.headerTitles[path] === "BAD") {
                            // Don't show those we can't translate
                            continue;
                        } else if (this.headerTitles[path] === undefined) {

                            const translationKey = 'topic_titles.' + path?.toLowerCase();
                            const topicHeader = this.context.t(translationKey);

                            if (topicHeader === translationKey) {
                                // Cache untranslateable ones
                                this.headerTitles[path] === "BAD"
                                continue;
                            }
                            this.headerTitles[path] = topicHeader;
                        }
                        sortedTopics.push(path);
                    }
                }
            }
        }

        let nodes = [];
        // Create header
        const headers = [];

        function getPopupTitle(topic) {
            return self.headerTitles[topic];
        }

        headers.push((
            <th key="idx">#</th>
        ));
        if (this.props.typeId !== 'i' || (!this.state._hasSensors || this.state._multiParents)) {
            headers.push((
                <th key="name">{sensorSubTypeToTitle[this.props.typeId]}</th>
            ));
        }
        if (this.state._hasSensors) {
            headers.push((
                <th key="pdu_name">PDU Name</th>
            ));
        }

        for (let i in sortedTopics) {
            const topic = sortedTopics[i];

            headers.push((
                <th key={"head-" + topic} className="text-right">{this.headerTitles[topic]}</th>
            ));
        }

        nodes.push((
            <tr key="tr-head">
                {headers}
            </tr>
        ));

        let pathIdx = 0;

        // Sort elements
        let sortedPaths = [];
        const sortingList = [];
        if (this.props.typeId !== "i" && this.props.typeId !== "o") {
            for (pathIdx in this.props.paths) {
                const path = this.props.paths[pathIdx];
                const topic = this.context.p.getPath(path);
                if (!topic) {
                    continue;
                }
                if (this.props.typeId === 's') {
                    // Sort sensors by pdu first and by name second
                    const parentPath = getNamedRoot(path);
                    sortingList.push({path: path, name: parentPath + topic.name});
                } else {
                    sortingList.push({path: path, name: topic.name});
                }
            }
            sortingList.sort((a, b) => {
                if (a.name > b.name) {
                    return 1;
                }
                if (a.name == b.name) {
                    return 0;
                }
                return -1;
            });
            for (let sortItem of sortingList) {
                sortedPaths.push(sortItem.path);
            }
        } else {
            sortedPaths = this.props.paths.sort();
        }

        let rowIdx = 0;

        for (pathIdx in sortedPaths) {
            const path = sortedPaths[pathIdx];
            let skipNameCol = true;

            if (this.props.typeId === 'i') {
                const inlet = this.context.p.getPath(path);
                skipNameCol = !this.state._hasSensors || this.state._multiParents;
                if (inlet?.parent) {
                    continue;
                }
            }

            let onlyShowType = null;
            if (this.props.typeId === 's') {
                const sensor = this.context.p.getPath(path);
                onlyShowType = sensor?.type;
            }

            nodes.push((
                <TypeGroupRow {...this.props} onlyShowType={onlyShowType} showInletNames={skipNameCol} getPopupTitle={getPopupTitle} hasPhases={this.state._hasPhases} phaseMap={this.state._rootToPhases[path]} key={ "tgr"+pathIdx } idx={++rowIdx } topics={sortedTopics} path={path} hasSensors={this.state._hasSensors} />
            ));
        }

        if (this.props.resultPath) {
            nodes.push((
                <TypeGroupRow {...this.props} key={ "tgresult" } topics={sortedTopics} hasPhases={this.state._hasPhases} showInletNames={this.props.typeId !== 'i' || !this.state._hasSensors || this.state._multiParents} path={this.props.resultPath} getPopupTitle={getPopupTitle} isMain={true} hasSensors={this.state._hasSensors} />
            ));
        }

        return (
            <div className="item group">
                <div className="inner">
                    <table cellSpacing="0" cellPadding="0">
                        <tbody>
                            {nodes}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

}


TypeGroupComponent.propTypes = {
    typeId: PropTypes.string.isRequired,
    paths: PropTypes.array.isRequired,
    pushCB: PropTypes.func.isRequired,
    subscribeSensor: PropTypes.func.isRequired,
    pushComponentCB: PropTypes.func.isRequired,
    resultPath: PropTypes.string,
    isCreatingReport: PropTypes.bool.isRequired,
    changeReportTopic: PropTypes.func.isRequired,
    reportTopics: PropTypes.array,
    showThresholdPopup: PropTypes.func.isRequired
};